import {
    IReceptionDay,
    IReceptionNotification,
    IReception,
    ISlot,
} from "@/models";

interface IReceptionState {
    receptionStartSlot: ISlot;
    receptionEndSlot: ISlot;
    receptionDay: IReceptionDay;
    notifications: IReceptionNotification[];
    selectedNotification: IReceptionNotification;
    selectedReception: IReception;
    validationPictures: string[];
}

const initialState: IReceptionState = {
    receptionStartSlot: {
        slotId: 21,
        startTime: "05:00:00",
        endTime: "05:15:00",
    },
    receptionEndSlot: {
        slotId: 85,
        startTime: "21:00:00",
        endTime: "21:15:00",
    },
    receptionDay: null,
    notifications: [],
    selectedNotification: null,
    selectedReception: null,
    validationPictures: [],
};

export { IReceptionState, initialState };
